<app-page-header
  text="Organic Makeup"
  backgroundImg="./assets/img/makeup-2.jpg"
></app-page-header>
<app-makeup-cards></app-makeup-cards>
<app-map></app-map>
